import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import request from '@/utils/request';
/**首页、数据看板的面板区资源 */
export function templatePanel(data) {
  return request.post('admin/template/panel', data);
}
/**首页、数据看板的字典资源 */
export function templateDictionary(data) {
  return request.post('admin/template/dictionary', data).then(res => {
    res.map(item => {
      item.children.map(item2 => {
        item2.label = item2.name;
        item2.value = String(item2.id) + ',' + item2.name;
        item2.checked = false;
      });
    });
    return res;
  });
}
/**首页、数据看板的字典资源 */
export function templateDetail(data) {
  return request.post('admin/template/detail', data);
}
/**模板添加 */
export function addTemplate(data) {
  return request.post('admin/template/store', data);
}
/**模板删除 (废弃)*/
export function delTemplate(data) {
  return request.post('admin/template/delete', data);
}